import { api } from '@/f1/service';
import _ from 'lodash'
import Language from './language';
import ruleI18n from '../rule.i18n'
import reg from '@/f1/reg'
import { VclFacebook } from 'vue-content-loading';
import 'flag-icon-css/css/flag-icon.css';
import Bell from 'vue-notification-bell'
import punycode from 'punycode/'

const _i18n_data = {
  get1: {
    EN : () => `"load", "failed"`,
    KO : () => `"로드", "실패"`,
  },
  password: {
    EN : () => `Password required.`,
    KO : () => `비밀번호를 입력하세요.`,
  }
};
export default {
  props: ['id', 'only_view'],
  components : { Language, VclFacebook, Bell },
  computed: {
    i18n_data() { return _i18n_data; },
    exception_policy_name() {
      return this.exception_info.detail.file ? _.last(this.exception_info.detail.file.replace('.conf', '').split('/')) : ''
    },
    exception_policy_msg() {
      return this.exception_info.msg ? this.exception_info.msg : ''
    },
    exception_policy_id() {
      return this.exception_info.detail ? this.exception_info.detail.ruleId : ''
    },
    get_domain_list() {
      if(!this.model.agent || !this.model.agent.policy || !this.model.agent.policy.domains) { return [] }
      return _.map(this.model.agent.policy.domains, x => x.domain)
    },
  }, // i18n 메세지 변환용.
  data : () => {
    return {
      info_base_policy : { reason : '', is_show : false },
      is_exception : false,
      info_threat : false,
      loading : false,
      detections : [],
      ruleI18n,
      info_xff : false,
      info_risk : false,
      view_split_uri : false,
      view_split_request : false,
      parser_request : false,
      is_error :false,
      model : { uri: '', message : { messages : [], unique_id : "", time_stamp : "" } },
      exception_info :  { detail : {}, agent_id : 0, msg : '', domain : 'default', applied : [], is_exception : false },
      exception_info_modal_add : false,
      exception_info_modal_remove : false,
    }
  },
  methods: {
    i18n_msessage() {
      try {
        return ruleI18n[this.model.m_id][this.i18n]
      } catch (e) {
        console.log(e)
        return this.message().message
      }
    },

    base_policy(msg) {
      this.info_base_policy.reason = msg
      this.info_base_policy.is_show = true
    },
    has_get_parameter() {
      try {
        if(!this.model.request) { return false }
        let x = this.model.request.split('?')
        if(x.length < 2) { return false }
        return true
      } catch (e) {
        console.log(e)
        return false
      }
    },
    parameter() {
      try {
        if(!this.has_get_parameter()) {
          return []
        }
        let x = Object.fromEntries(new URLSearchParams(this.model.uri.split('?')[1]))
        return  _.map(Object.keys(x), y => { return { key : y, value : x[y] } })
      } catch (e) {
        console.log(e)
        return []
      }
    },
    policy_domain() {
      try {
        let x = this.message()
        if(!x || !x.details) { return '' }
        let xx = x.details.file.split('/')
        return xx[xx.length - 1].replace('.conf', '')
      } catch (e) {
        console.log(e)
        return ''
      }
    },
    tags() {
      try {
        let x = this.message()
        console.log('x', x, x.details)
        return x ? Object.values(x.details.tags) : []
      } catch (e) {
        console.log(e)
        return ''
      }
    },
    message() {
      try {
        // if(this.model.title) { return this.model.title }
        if(this.model.message.messages && this.model.message.messages.length < 1) { return '' }

        return this.model.message.messages[0]
      } catch (e) {
        console.log(e)
        return ''
      }
    },
    method(x) { return x && x.indexOf(' ') > -1 ? x.split(" ")[0] : '' },
    set_flag(x) { return `flag-icon flag-icon-${x.toLowerCase()}` },
    add_white : async function(detail, agent_id) {
      // let domain = _.last(this.exception_info.detail.file.replace('.conf', '').split('/'))
      let domain = this.exception_info.domain
      let rs = await api.webcastle.WebCastle({ target : 'log', cmd : 'update.exception.add', body : { agent_id : this.exception_info.agent_id, rule_id : this.exception_info.detail.ruleId, domain_list : domain } })
      if(rs.error) {
        return this.$toastr.e(rs.reason)
      }
      this.$toastr.s("exception updated")
      console.log(this.$parent.$parent, 'reload')
      this.$parent.$emit("reload")
      this.get()
    },
    remove_white : async function(detail, agent_id) {
      // let domain = _.last(this.exception_info.detail.file.replace('.conf', '').split('/'))
      let domain = this.exception_info.domain
      let rs = await api.webcastle.WebCastle({ target : 'log', cmd : 'update.exception.remove', body : { agent_id : this.exception_info.agent_id, rule_id : this.exception_info.detail.ruleId, domain_list : domain } })
      if(rs.error) {
        return this.$toastr.e(rs.reason)
      }
      this.$toastr.s("exception updated")
      this.$parent.$emit("reload")
      this.get()
    },
    split_uri_parser(x, len = window.innerWidth / 15) {
      let total = x.length
      let start = 0
      let rs = ""
      while (total > start) {
        rs += x.substr(start, len) + '\\\r\n'
        start += len
      }
      this.parser_request = true
      return rs.substr(0, rs.length - 4);
    },
    split_uri(uri) { return uri && uri.length > 100 ? this.split_uri_parser(uri) : uri },
    list() { this.$router.push({ name: 'webcastle_log'}); },
    async get({ id } = this.$route.params) {
      this.loading = true
      if(this.id && this.id > 0)  {
        id = this.id
      } else
      console.log('detect.detail.vue', 'load item', id);

      if(!id) {
        this.loading = false
        console.log('detect.detail.vue', 'no have id', id);
        return
      }

      try {
        let rs = await api.webcastle.WebCastle_Call('log', 'detail', { id : id })
        if(rs.error) { return this.$toastr.e(this.i18n_msg('get1') || '"load", "failed"'); }
        this.model = Object.assign({}, this.model, rs.body);
        // this.model.message = JSON.parse(this.model.message);
        try { this.model.message = JSON.parse(this.model.message) }
        catch (e) {
          console.log(this.model.message)
          console.log("json parser failed");
          this.is_error = true;
        }

        this.model.detect_cnt = 0
        this.model.block_cnt = 0
        this.model.agent.policy = JSON.parse(this.model.agent.policy)
        // let name = this.policy_domain()
        const regex = /(Value: .* )/gm;


        _.forEach(this.model.message.messages, rule => {
          rule.is_info = rule.message.toLowerCase().indexOf('geoip') > -1
          rule.is_exception = false

          if(!rule.is_info && this.model.is_block) {
            rule.is_detect = _.startsWith(rule.message.toLowerCase(), '[detectiononly]')
            rule.is_detect ? (this.model.detect_cnt += 1) : (this.model.block_cnt += 1)
          }

          try {
            let m
            while ((m = regex.exec(rule.details.match)) !== null) {
              // This is necessary to avoid infinite loops with zero-width matches
              if (m.index === regex.lastIndex) {
                  regex.lastIndex++;
              }

              // The result can be accessed through the `m`-variable.
              m.forEach((match, groupIndex) => {
                rule.value = match
                console.log(`Found match, group ${groupIndex}: ${match}`);
              });
            }

            // https://github.com/mathiasbynens/punycode.js
            // 기본 라이브러리 punycode 는 사용 불가

            if(_.startsWith(this.model.target, 'xn--')) { this.model.target = punycode.toUnicode(this.model.target) }
            if(_.startsWith(this.model.host, 'xn--')) { this.model.host = punycode.toUnicode(this.model.host) }
          } catch (e) {
            console.log(e)
          }

          try {
            // console.log(_.filter(this.model.agent.policy.domains, x => {
            //   console.log(x.rule, rule.details.ruleId, _.indexOf(x.rule, rule.details.ruleId) > -1)
            //   return _.indexOf(x.rule, rule.details.ruleId) > -1
            // }))
            rule.exception_list = _.map(_.filter(this.model.agent.policy.domains, x => _.indexOf(x.rule, rule.details.ruleId) > -1), x => x.domain)
            console.log('rule.exception_list', rule.exception_list, this.policy_domain(), this.model.target)


            rule.is_exception = rule.exception_list.length > 0
            rule.is_exception_domain = _.filter(rule.exception_list, x => x == this.model.target).length > 0
            rule.is_domain = this.model.target && _.findIndex(this.model.agent.policy.domains, x =>  x.domain == this.model.target) > -1
            // 탐지된 그 순간이 아니여서 버그 있음...............................................

            // .forEach(x => {
            //   // console.log(x.rule, rule.details.ruleId)
            //   console.log(x.rule.indexOf(rule.details.ruleId) > -1)
            //   if(x.rule.indexOf(rule.details.ruleId) > -1) {

            //   }
            // })


          } catch (e) {
            console.log('checking exception', e)
          }
        })

        if(this.model.message.messages) {
          this.model.message.messages = _.sortBy(this.model.message.messages, ['is_detect', 'details.severity']).reverse()
        }
        if(!this.model.message.unique_id) { this.is_error = true }

        // console.log(this.model.message.messages[0].message)
        _.forEach(this.model.headers ? this.model.headers.split('\n') : [], line => {
          let ip = line.replace(/(x-forwarded-for:| )/ig, '')
          console.log('ip', _.startsWith(line.toLowerCase(), 'x-forwarded-for') && reg.ip4.test(ip))
          _.startsWith(line.toLowerCase(), 'x-forwarded-for') && reg.ip4.test(ip) ? (this.model.xff = ip) : ''
        })


        console.log(this.model.agent.policy)
      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message : e.statusText) , this.list() }
      finally {
        this.loading = false
      }
    }
  },
  watch: {
    '$route' (to, from) { this.get(to.params, from); },
    'id' (to, from) { this.get(); }
  },
  created() { console.log('detect.detail.vue', 'created'); },
  destroyed() { console.log('detect.detail.vue', 'destroyed'); },
  mounted() {
    console.log('detect.detail.vue', 'mounted');
    this.get(this.$route.params);
  },
}
